import { Expose } from 'class-transformer';
import { RequestCriteria } from 'src/app/shared/model/request-criteria';
import { SetOfFiltersType } from './set-of-filters-type';

export class SetOfFilters {
  @Expose({ name: 'id' })
  id: number;

  @Expose({ name: 'name' })
  name: string;

  @Expose({ name: 'type' })
  type: SetOfFiltersType;

  @Expose({ name: 'data_type' })
  dataType: string;

  @Expose({ name: 'criteria' })
  criteria: RequestCriteria;

  constructor(dataType: string, criteria: RequestCriteria) {
    this.dataType = dataType;
    this.criteria = criteria;
  }

  get readOnly(): boolean {
    return this.type == SetOfFiltersType.READ_ONLY;
  }
}
